<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-end hide-mobile">
    Programmiert von
    <a
      href="https://love-it.at/"
      target="_blank"
      ><img
        src="assets/images/logo/{{ coreConfig.layout.skin == 'dark' ? 'LOVE–IT_Logo-dark.svg' : 'LOVE–IT_Logo.svg' }}"
        width="75"
        alt="LOVE-IT Logo"
    /></a>
  </span>
</p>
@if (!isOesterreichZeitzone) {
  <love-it-alert type="warning"
    >Sie befinden sich nicht in der österreichischen Zeitzone, daher kann es zu Abweichungen bei Daten und Zeiten
    kommen!</love-it-alert
  >
}
<!--/ Footer -->

<!-- Move to top Button-->
@if (coreConfig.layout.scrollTop) {
  <app-scroll-top></app-scroll-top>
}
